import ICMAxios from "../ICMAxios";
import { ILogin } from "../../interfaces/ILogin";

const loginService = {
  login: (LoginObj: ILogin): Promise<any> =>
    ICMAxios.post<any>("v1/Login", LoginObj),
};

export default loginService;
